var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#verified_svg__clip0_7355_5550)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#verified_svg__filter0_d_7355_5550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3L5 5.912v12.765l.654.433C7.52 20.318 9.743 20.97 12 21c2.257-.03 4.481-.682 6.346-1.89l.654-.403V5.912L12 3z",
    fill: "url(#verified_svg__paint0_linear_7355_5550)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#verified_svg__filter1_d_7355_5550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.417 14.218l4.98-4.98.765.766-5.745 5.746-3.447-3.447.766-.767 2.681 2.682z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "verified_svg__filter0_d_7355_5550",
    x: 1,
    y: 1,
    width: 22,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7355_5550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7355_5550",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "verified_svg__filter1_d_7355_5550",
    x: 7.97,
    y: 9.238,
    width: 9.192,
    height: 7.511,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.093125 0 0 0 0 0.26463 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7355_5550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7355_5550",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "verified_svg__paint0_linear_7355_5550",
    x1: 15.063,
    y1: 4.636,
    x2: 5.918,
    y2: 19.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1154DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "verified_svg__clip0_7355_5550"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/verified.svg";
export { SvgVerified as ReactComponent };